import { useDispatch, useSelector } from 'react-redux'

import { SadFaceIcon } from 'primsell-shared-layer/assets/icons'
import { Button } from 'primsell-shared-layer/components'

import { currentStepSelector, RedeemActions, redeemErrorSelector } from 'features'
import { REDEEM_PROGRESS_STEPS } from '../redeem-progress-modal.config'

import * as S from '../redeem-progress-modal.styles'

function BurnDialogContent() {
  const dispatch = useDispatch()
  const error = useSelector(redeemErrorSelector)
  const currentStep = useSelector(currentStepSelector)

  return (
    <S.Form>
      <S.TitleIcon>
        {!error ? REDEEM_PROGRESS_STEPS[currentStep].icon : <SadFaceIcon style={{ width: 40, height: 60 }} />}
      </S.TitleIcon>
      <S.BurnDialogTitle>
        {!error ? REDEEM_PROGRESS_STEPS[currentStep].modalTitle : 'Oops... something went wrong!'}
      </S.BurnDialogTitle>
      <S.BurnDialogDesc color="grey">
        {!error ? REDEEM_PROGRESS_STEPS[currentStep].description : error}
      </S.BurnDialogDesc>
      {error && (
        <Button color="dark" variant="filled" onClick={() => dispatch(RedeemActions.tryAgain())}>
          Try Again
        </Button>
      )}
    </S.Form>
  )
}

export { BurnDialogContent }
